import gql from 'graphql-tag'

export const CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_DELETE_MUTATION = gql`
    mutation consultantNotificationEmailAddressDelete(
        $id: ID!
        $forceDelete: Boolean!
    ) {
        consultantNotificationEmailAddressDelete(
            id: $id
            force_delete: $forceDelete
        ) {
            status
        }
    }
`
